import { createSearchParams, Location, useLocation, useNavigate } from 'react-router';

import { RouteEnum } from '@/models/route/Route.model.ts';

export type PathParams = { params: Record<string, string>; pathname: Path } | Path;
type Path = RouteEnum | string;

interface Return {
  location: Location;
  /** Optional serializable data read by the destination via `useLocation().state`. */
  push: (path: PathParams, state?: Record<string, unknown>) => void;
}

export const useAppNavigation = (): Return => {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    location,
    push: (path, state) => {
      if (typeof path === 'object') {
        navigate(
          {
            pathname: path.pathname,
            search: `?${createSearchParams(path.params)}`,
          },
          {
            state,
            viewTransition: true,
          },
        );
        return;
      }
      void navigate(path, { state, viewTransition: true });
    },
  };
};
